import React, { useContext, useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import LayoutContext from '../LayoutContext';
import { useLocation } from 'react-router';
import useWidth from 'services/Hooks/useWidth';

const SidebarToggleHandler = ({ children, ...restProps }) => {
  const location = useLocation();
  const width = useWidth();

  const { isSidebarOpen, setSidebarOpen } = useContext(LayoutContext);

  useEffect(() => {
    if (width !== 'lg' && width !== 'xl' /*&& isSidebarOpen*/) {
      setSidebarOpen(false);
    } else {
      setSidebarOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, width]);

  return (
    <IconButton className="Cmt-toggle-menu" onClick={() => setSidebarOpen(!isSidebarOpen)} {...restProps} size="large">
      {children || <MenuIcon />}
    </IconButton>
  );
};

export default SidebarToggleHandler;
